import React from "react";
import cn from "classnames";
import infoIcon from "@src/assets/svg/info-icon-yellow.svg";
import { useI18N } from "@src/language/language-context";
import styles from "./auto-generate-certificate-setting.module.scss";
import { ToggleButton } from "../toggle-button/toggle-button";

interface AutoGenerateCertificateSettingPropTypes {
  isAutoGenerateEnabled: boolean;
  onToggle: () => void;
  showReuseGeneratedCertificateHint?: boolean;
}

const cssClassName = "auto-generate-certificate-setting";

export const AutoGenerateCertificateSetting = ({
  isAutoGenerateEnabled,
  onToggle,
  showReuseGeneratedCertificateHint = false,
}: AutoGenerateCertificateSettingPropTypes) => {
  const i18n = useI18N();

  const texts = {
    labelText: i18n("modules.autoGenerateCertificateSetting.labelText"),
    uploadInfoText: i18n(
      "modules.autoGenerateCertificateSetting.uploadInfoText",
    ),
    generatedInfoText: i18n(
      "modules.autoGenerateCertificateSetting.generatedInfoText",
    ),
    infoIconAltText: i18n(
      "modules.autoGenerateCertificateSetting.infoIconAltText",
    ),
    reuseGeneratedCertificateHintText: i18n(
      "modules.autoGenerateCertificateSetting.reuseGeneratedCertificateHintText",
    ),
  };

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__info`]}>
        <img
          className={styles[`${cssClassName}__info-icon`]}
          src={infoIcon}
          alt={texts.infoIconAltText}
        />
        <p className={styles[`${cssClassName}__info-text`]}>
          {isAutoGenerateEnabled
            ? texts.generatedInfoText
            : texts.uploadInfoText}
        </p>
      </div>

      <div
        className={cn(styles[`${cssClassName}__switch-box`], {
          [styles[`${cssClassName}__switch-box--active`]]:
            isAutoGenerateEnabled,
        })}
      >
        <div className={styles[`${cssClassName}__switch-box-labels`]}>
          <span className={styles[`${cssClassName}__switch-box-text`]}>
            {texts.labelText}
          </span>
          {showReuseGeneratedCertificateHint && (
            <p className={styles[`${cssClassName}__reuse-generated-cert-text`]}>
              {texts.reuseGeneratedCertificateHintText}
            </p>
          )}
        </div>
        <ToggleButton isActive={isAutoGenerateEnabled} handleClick={onToggle} />
      </div>
    </div>
  );
};
